<template>
  <Page title="Tag Management" class="w-full">
    <TabSwitcher id="tag" :tabs="tabs" class="w-full" />
  </Page>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { EventBus } from "@/lib/event_bus.js";
import { updateQueryParam } from "@/lib/url";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import TagsDatatable from "./TagsDatatable.vue";

interface Filter {
  type: string;
  name: string;
  label: string;
  placeholder?: string;
  options?: Array<{ label: string; value: string }>;
  multiple?: boolean;
}

const props = defineProps<{
  customerTagsSource: string;
  jobTagsSource: string;
  customerFilters: Filter[];
  jobFilters: Filter[];
}>();

const liveCustomerFilters = ref<Filter[]>([...props.customerFilters]);
const liveJobFilters = ref<Filter[]>([...props.jobFilters]);

const tabs = computed(() => [
  {
    id: "customer_tags",
    name: "Customer",
    component: TagsDatatable,
    props: {
      source: props.customerTagsSource,
      filters: liveCustomerFilters.value,
      taggableType: "customer"
    },
    beforeTabChange: (ref) => {
      updateQueryParam("label", null);
      updateQueryParam("description", null);
      return true;
    }
  },
  {
    id: "job_tags",
    name: "Job",
    component: TagsDatatable,
    props: {
      source: props.jobTagsSource,
      filters: liveJobFilters.value,
      taggableType: "job"
    },
    beforeTabChange: (ref) => {
      updateQueryParam("label", null);
      updateQueryParam("description", null);
      return true;
    }
  }
]);

const updateTagFilters = (tagType: string, filters: Filter[]) => {
  if (tagType === "customer") {
    liveCustomerFilters.value = [...filters];
  } else if (tagType === "job") {
    liveJobFilters.value = [...filters];
  }
};

onMounted(() => {
  EventBus.$on("update-tag-filters", updateTagFilters);
});

onBeforeUnmount(() => {
  EventBus.$off("update-tag-filters", updateTagFilters);
});
</script>
